module.exports = __webpack_public_path__ + "static/media/Light_Divider@3x.d83f38df.png";